import React, { useEffect, useState } from "react";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import { Button, Col, Container, Form, Row, Modal } from "react-bootstrap";
import PersonalDetails from "./PersonalDetails";
import CommunicationDetails from "./CommunicationDetails";
import axios from "axios";
import Sweetalert from "../../../CommonUtilities/CommonPopupAndAlerts/SweetAlerts";
import PublicHeader from "../../../Header/PublicHeader";
import { config } from "../../../CommonUtilities/CommonUrl/CommonUrls";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { regValidationSchema } from "../../../CommonUtilities/Validations/Validations";
import { DecodeAuthToken } from "../../../../Auth/CandidateLogin";
import { useDispatch } from "react-redux";
import { FaCopy, FaWindowClose } from "react-icons/fa";
import UserManual from "./UserManual";
import UserManualButtons from "./UserManualButtons";
import {
  ACADEMIC_YEAR,
  CONTEXT_COMMON_NAME,
  CONTEXT_NAME,
} from "../../../CommonUtilities/Validations/RegularExpAndVar";
import KnowUserId, {
  KnowUser,
  userValidationSchema_know,
} from "../../../../Auth/KnowUserId";
import { CommomLoginAunthenticatePost } from "../../../CommonUtilities/CommonAxios/CommonAxios";
import { IoCheckmarkSharp } from "react-icons/io5";
import { AiOutlineClose } from "react-icons/ai";
import EducationDetails from "./EducationDetails";
const VIDEO_LINKS = {
  video1: "https://youtu.be/JQ92XJwpZQ8", // Replace VIDEO_ID_1 with actual YouTube video ID
  video2: "https://youtu.be/eyXIaNtOI6o", // Replace VIDEO_ID_2 with actual YouTube video ID
};

export default function RegistrationForm() {
  const navigate = useNavigate();
  const [disableField, setDisableField] = useState(false);
  const [showOtpBtn, setOtpBtn] = useState(true);
  const [resendOtp, setResendOtp] = useState(false);
  const [showStatus, setStatus] = useState(false);
  const [candidateId, setcandidateId] = useState();
  const [showDeclaration, setShowDeclaration] = useState(true); //(true)
  const [showUserManual, setShowUserManual] = useState(false);
  const [showVideo1, setShowVideo1] = useState(false);
  const [showVideo2, setShowVideo2] = useState(false);

  const Formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      ...getInitialValues(),
      typeOfStudy: "",
      district1: "",
      district2: "",
      district3: "",
      district4: "",
      district5: "",
      district6: "",
      district7: "",
      localDistCode: "",
    },
    onSubmit: (values, { resetForm }) => handleFormSubmit(values, resetForm),
    validationSchema: regValidationSchema,
  });

  function handleFormSubmit(values, resetForm) {
    if (values?.selfCheck) {
      sendOtp(values, resetForm);
    } else {
      Sweetalert("Please confirm the declaration to proceed.", "warning");
    }
  }

  const dispatch = useDispatch();
  function sendOtp(values, resetForm) {
    Swal.fire({
      title: "Are you Sure Want to Submit?",
      html: `Make Sure , OTP will be Send to <span style="color: blue;">${values?.mobileNo}</span>`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Send OTP",
    }).then((res) => {
      if (res.isConfirmed) {
        let otpUrl =
          config.url.CONTEXT_URL +
          "kgbv-public/generateotp?mobile=" +
          values?.mobileNo;
        axios.post(otpUrl, values).then((rres) => {
          if (rres?.data?.status === true) {
            setOtpBtn(false);
            setTimer(180);
            setDisableField(true);
            setResendOtp(false);
          } else if (rres?.data?.scode === "03") {
            Sweetalert(rres?.data?.sdesc, "warning");
            setSelectedValue();
            //setSelectedValue();
            resetForm();
            Formik.setFieldValue("caste", "");
          } else {
            resetForm();
            Formik.setFieldValue("caste", "");
            setSelectedValue();
            // setSelectedValue();
            Sweetalert(rres?.data?.sdesc, "warning");
          }
        });
      }
    });
  }

  const [resToken, setResToken] = useState("");

  function submitValues() {
    let values = Formik?.values;
    let url = config.url.CONTEXT_URL + "kgbv-public/candidate-registration";
    if (values?.otp) {
      axios.post(url, values).then((res) => {
        if (res?.data?.status === true) {
          setcandidateId(res?.data?.candidate_id);
          let data = res?.data?.auth;
          setResToken(data);
          setStatus(true);
        } else {
          Formik.setFieldValue("otp", "");
          Sweetalert(res.data?.sdesc, "warning");
        }
      });
    } else {
      Sweetalert("Please Enter OTP /  Valid OTP", "error");
    }
  }

  const [timer, setTimer] = useState(180);
  useEffect(() => {
    let interval = null;
    if (!showOtpBtn) {
      interval = setInterval(() => {
        setTimer((prevTimer) => {
          if (prevTimer > 0) {
            if (prevTimer < 122) {
              setResendOtp(true);
              return prevTimer - 1;
            } else if (prevTimer > 1) {
              return prevTimer - 1;
            } else {
              clearInterval(interval);
              setResendOtp(true);
              return 0;
            }
          }
        });
      }, 1000);
    } else {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [showOtpBtn]);

  const formatTime = (timeInSeconds) => {
    if (isNaN(timeInSeconds) || timeInSeconds < 0) {
      return "0:00";
    }
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = timeInSeconds % 60;
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  const resendOTP = () => {
    Formik.setFieldValue("otp", "");
    let values = Formik?.values;
    sendOtp(values);
  };

  const [Castes, setCastes] = useState([]);
  const [totalCastes, settotalCastes] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null);
  const getcasteFunction = async () => {
    let villUrl = config.url.CONTEXT_READ_URL + "kgbv-public/sub-castes";
    const response = await axios.get(villUrl);
    if (response?.data?.status === true) {
      settotalCastes(response?.data?.data);
      const uniqueCasteNames = [
        ...new Set(response?.data?.data?.map((item) => item.caste_name)),
      ];
      setCastes(
        uniqueCasteNames?.map((subcaste) => ({
          value: subcaste,
          label: subcaste,
        })),
      );
    }
  };
  useEffect(() => {
    getcasteFunction();
  }, []);

  const [subCastes, setSubCastes] = useState();
  const [selectedsubcasteValue, setSelectedsubcasteValue] = useState(null);
  const handleCasteChange = async (selectedOption) => {
    let sub = totalCastes
      ?.filter((val) => val?.caste_name === selectedOption?.value)
      ?.map((subcaste) => ({
        value: subcaste.sub_caste_code,
        label: `${subcaste.sub_caste_name}(${subcaste.sub_caste_name_in_telugu})`,
      }));
    Formik.setFieldValue("caste", selectedOption?.value);
    Formik.setFieldValue("subCasteCode", "");
    setSelectedsubcasteValue(null);
    setSelectedValue(selectedOption);
    setSubCastes(sub);
  };

  const [disclaimerChecks, setDisclaimerChecks] = useState({
    readInstructions: false,
    // accurateDetails: false,
    falseInfo: false,
    // processChanges: false,
    hereby: false,
    informationbullet: false,
    nonLocal: false,
    //uploadbullet: false
  });

  const allChecked = Object.values(disclaimerChecks).every(Boolean);

  function handleDisclaimerCheck(key) {
    setDisclaimerChecks((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  }
  const [knowUser, setKnowUser] = useState("");

  const [refreshCaptcha, setRefreshCaptcha] = useState("");
  const [candidId, setCandidId] = useState("");
  const [candidName, setCandidName] = useState("");
  const handleRefreshCaptcha = () => {
    formIk.setFieldValue("captchaId", "");
    formIk.setFieldValue("captcha", "");
    let url = config.url.CONTEXT_URL + "kgbv-public/generate-captcha";
    axios.post(url).then((res) => {
      if (res?.data?.status === true) {
        setRefreshCaptcha(res.data.captcha);
        formIk.setFieldValue("captchaId", res.data.captchaId);
      }
    });
  };

  useEffect(() => {
    handleRefreshCaptcha();
  }, []);

  const submitDetails = async (values, resetForm) => {
    let url = config.url.CONTEXT_URL + "kgbv-public/know-candidate";
    CommomLoginAunthenticatePost(url, values).then((res) => {
      if (res?.data?.status === true) {
        setKnowUser("YES");
        // setShowDeclaration(false);
        setCandidName(res?.data?.data[0]?.applicant_name);
        setCandidId(res?.data?.data[0]?.candidate_id);
        // let htmltext = `Your Candidate Id is <span style="color: blue;">${res.data.data[0]?.candidate_id}</span>`
        // Swal.fire({
        //   html: htmltext,
        //   icon: "success",
        //   backdrop: false,
        //   confirmButtonColor: "#3085d6",
        //   confirmButtonText: "Click Here to login",
        // }).then((update) => {
        //   if (update.isConfirmed) {
        //     window.location.href = "/";
        //   }
        // })
        resetForm();
      } else {
        setKnowUser("NO");
        handleRefreshCaptcha();
        // Sweetalert('Invalid Credentails', "error")
      }
    });
  };

  const formIk = useFormik({
    initialValues: {
      aadhaarNo: "",
      mobile: "",
      captcha: "",
      captchaId: "",
    },
    validationSchema: userValidationSchema_know,
    onSubmit: (values, { resetForm }) => {
      console.log("values", values);
      submitDetails(values, resetForm);
    },
  });
  document.body.classList.add("jnb-bg");
  const [copied, setCopied] = useState(false);
  const handleCopyText = () => {
    const textToCopy = document.getElementById("textToCopy").innerText;
    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        console.log("Text copied to clipboard");
        setCopied(true);
        setTimeout(() => {
          setCopied(false);
        }, 3000);
      })
      .catch((err) => {
        console.error("Failed to copy text: ", err);
      });
  };
  return (
    <React.Fragment>
      <PublicHeader />

      {/* Declaration Popup */}
      <div className="pop">
        <Modal
          size="lg "
          show={showDeclaration}
          backdrop="static"
          keyboard={false}
          centered
          className="kgbv-gomodal"
        >
          <Modal.Header className="kgbv-modalheader justify-content-between">
            <Modal.Title className="disclaimer">New Registration</Modal.Title>
            <button
              type="button"
              className="btn btn-end text-white p-0"
              onClick={() => {
                setShowDeclaration(false);
                navigate("/");
              }}
              style={{ fadeType: "out" }}
              aria-label="Close"
            >
              <h4 className="mb-0">
                <AiOutlineClose />
              </h4>
            </button>
          </Modal.Header>
          <Modal.Body>
            {/* {knowUser === "YES" ? ( */}
              {/* <div className="alert alert-info">
                <h3 className="mt-4 border p-3 fs-6 w-100">
                  <strong>Dear {candidName},</strong>
                  <pre />
                  You are already Registered to {CONTEXT_COMMON_NAME} -{" "}
                  {ACADEMIC_YEAR} ,<pre />
                  Username :{" "}
                  <span style={{ color: "brown" }} id="textToCopy">
                    {candidId}
                  </span>
                  &nbsp;{" "}
                  {copied ? (
                    <>
                      <IoCheckmarkSharp color="green" size={30} />
                      Copied!{" "}
                    </>
                  ) : (
                    <FaCopy
                      onClick={() => {
                        handleCopyText();
                      }}
                    />
                  )}
                  <br />
                  Password : existing password ({" "}
                  <a
                    href="/ForgotPassword"
                    className="rounded-lg bg-gray-200 text-gray-800 font-medium hover:bg-gray-300"
                  >
                    Forgot Password?
                  </a>{" "}
                  )
                  <br />
               
                  <span>
                    {" "}
                    <i
                      style={{ background: "#2a9d8f" }}
                      className="badge badge-success forgot fw-bold"
                      onClick={() => navigate("/")}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          navigate("/");
                        }
                      }}
                      data-toggle="tooltip"
                      animation="true"
                    >
                      {" "}
                      Click Here{" "}
                    </i>{" "}
                  </span>{" "}
                  to login.
                </h3>
              </div> */}
            {/* ) : knowUser === "NO" ? ( */}

              <div className="mb-3">
                <ul
                  className="declaration-list"
                  style={{ listStyle: "none", padding: 0 }}
                >
                  <li className="mb-3 d-flex align-items-start">
                    <Form.Check
                      type="checkbox"
                      id="read-instructions"
                      className="me-2 "
                      checked={disclaimerChecks.readInstructions}
                      onChange={() => handleDisclaimerCheck("readInstructions")}
                    />
                    <label
                      htmlFor="read-instructions"
                      className="form-check-label"
                      style={{ cursor: "pointer" }}
                    >
                      Applicants are advised to read the
                      notification/instructions carefully before proceeding with
                      the application.
                    </label>
                  </li>
                  
                  <li className="mb-3 d-flex align-items-start">
                    <Form.Check
                      type="checkbox"
                      id="false-info"
                      className="me-2 "
                      checked={disclaimerChecks.falseInfo}
                      onChange={() => handleDisclaimerCheck("falseInfo")}
                    />
                    <label
                      htmlFor="false-info"
                      className="form-check-label"
                      style={{ cursor: "pointer" }}
                    >
                      Any false or misleading information is liable to
                      disqualification at any stage of the recruitment process.
                    </label>
                  </li>
                
                  <li className="mb-3 d-flex align-items-start">
                    <Form.Check
                      type="checkbox"
                      id="here-by"
                      className="me-2 "
                      checked={disclaimerChecks.hereby}
                      onChange={() => handleDisclaimerCheck("hereby")}
                    />
                    <label
                      htmlFor="here-by"
                      className="form-check-label"
                      style={{ cursor: "pointer" }}
                    >
                      By proceeding, you agree that you understand and accept
                      all terms and conditions mentioned in the official
                      notification.
                    </label>
                  </li>
                  <li className="mb-3 d-flex align-items-start">
                    <Form.Check
                      type="checkbox"
                      id="accurate-details"
                      className="me-2 "
                      checked={disclaimerChecks.informationbullet}
                      onChange={() =>
                        handleDisclaimerCheck("informationbullet")
                      }
                    />
                    <label
                      htmlFor="accurate-details"
                      className="form-check-label"
                      style={{ cursor: "pointer" }}
                    >
                      I’ve read through the information bulletin and understood
                      all the important details and instructions.
                    </label>
                  </li>
                   <li className="mb-3 d-flex align-items-start">
                    <Form.Check
                      type="checkbox"
                      id="non-local"
                      className="me-2 "
                      checked={disclaimerChecks.nonLocal}
                      onChange={() => handleDisclaimerCheck("nonLocal")}
                    />
                    <label
                      htmlFor="non-local"
                      className="form-check-label"
                      style={{ cursor: "pointer" }}
                    >
                      Non-local candidates are not eligible for this recruitment process.
                       Please ensure you meet the local eligibility criteria before proceeding.
                    </label>
                  </li>
                 
                </ul>
              </div>
            {/* ) : (
              <KnowUser
                formIk={formIk}
                handleRefreshCaptcha={handleRefreshCaptcha}
                refreshCaptcha={refreshCaptcha}
              />
            )} */}
          </Modal.Body>
           <Modal.Footer>
            {/* {!knowUser && (
              <Button
                type="button"
                variant="success"
                size="sm"
                onClick={formIk.handleSubmit}
                className="px-4"
              >
                Submit{" "}
              </Button>
            )} */}
            {/* {knowUser === "NO" && ( */}
              <Button
                variant="success"
                size="sm"
                className="px-4"
                disabled={!allChecked}
                onClick={() => setShowDeclaration(false)}
              >
                Proceed
              </Button>
            {/* )} */}
          </Modal.Footer> 
        </Modal>
      </div>
      
      <Modal
        show={showVideo1}
        onHide={() => setShowVideo1(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>User Manual English (Video)</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div className="ratio ratio-16x9">
            <iframe
              src={`https://www.youtube.com/embed/${
                VIDEO_LINKS.video1.split("v=")[1]
              }`}
              title="User Manual English (Video)"
              allowFullScreen
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            ></iframe>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowVideo1(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Video 2 Modal */}
      <Modal
        show={showVideo2}
        onHide={() => setShowVideo2(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title> User Manual Telugu (Video)</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div className="ratio ratio-16x9">
            <iframe
              src={`https://www.youtube.com/embed/${
                VIDEO_LINKS.video2.split("v=")[1]
              }`}
              title=" User Manual Telugu (Video)"
              allowFullScreen
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            ></iframe>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowVideo2(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      {allChecked && (
        <Container className="application-container pt-3 mt-5">
          <div className="heading-main mt-4 d-flex justify-content-between align-items-center">
            <h3 className="main-title">Registration Form</h3>
            <Button
              variant="outline-info"
              className="manual-button"
              size="sm"
              onClick={() => setShowUserManual(!showUserManual)}
            >
              {showUserManual ? "Hide User Manual" : "Show User Manual"}
            </Button>
          </div>

          {showUserManual && <UserManual />}

          <FormikProvider value={Formik}>
            <Form
              className="form-section mb-4"
              onSubmit={Formik.handleSubmit}
              onChange={Formik.handleChange}
            >
              {showStatus === true ? (
                <Row>
                  <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                    <h5>
                      Dear{" "}
                      <span
                        style={{ fontFamily: "bold" }}
                        className="text-danger"
                      >
                        {Formik?.values?.applicantName}
                      </span>
                      , You have successfully Registered Basic Details for{" "}
                      {CONTEXT_NAME} {ACADEMIC_YEAR} . <br />
                      <br />
                    </h5>
                  </Col>
                  <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                    <h5>
                      User ID :
                      <span style={{ color: "blue", fontFamily: "bold" }}>
                        {" "}
                        {candidateId}
                      </span>
                      <br />
                      Password : sent to your registered Mobile No. ({" "}
                      <span className="text-success">
                        {Formik?.values?.mobileNo.slice(0, 3) +
                          "x".repeat(5) +
                          Formik?.values?.mobileNo.slice(8)}
                      </span>{" "}
                      ).
                      <br />
                      <br />
                      <i
                        className="badge badge-success forgot mb-4 fw-bold "
                        data-toggle="tooltip"
                        animation="true"
                        title="Click Me!"
                        onClick={() => {
                          DecodeAuthToken(resToken, dispatch, navigate);
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            DecodeAuthToken(resToken, dispatch, navigate);
                          }
                        }}
                      >
                        {" "}
                        Click Here to Login
                      </i>{" "}
                      and Complete Your Application.
                    </h5>
                  </Col>
                </Row>
              ) : (
                <React.Fragment>
                  <PersonalDetails
                    Formik={Formik}
                    showPhoto="false"
                    disableField={disableField}
                    selectedsubcasteValue={selectedsubcasteValue}
                    subCastes={subCastes}
                    Castes={Castes}
                    handleCasteChange={handleCasteChange}
                    setSelectedsubcasteValue={setSelectedsubcasteValue}
                    selectedValue={selectedValue}
                  />
                  <CommunicationDetails
                    className="mt-4"
                    Formik={Formik}
                    disableField={disableField}
                  />
                  <EducationDetails Formik={Formik} from="registration" />
                  <Row className="pb-0 pt-2 mx-0">
                    <Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      xxl={12}
                      className="alert alert-warning"
                    >
                      {" "}
                      &nbsp;
                      <Field
                        type="checkbox"
                        name="selfCheck"
                        className="form-sub"
                        onChange={(e) => {
                          const isChecked = e.target.checked;
                          Formik.setFieldValue(
                            "selfCheck",
                            isChecked ? true : null,
                          );
                        }}
                      />{" "}
                      &nbsp;I Hereby ,declare that all the above information is
                      correct to the best of my knowledge.
                      <ErrorMessage
                        name="selfCheck"
                        component="div"
                        className="text-error"
                      />{" "}
                    </Col>
                  </Row>
                  <Row className="pb-4">
                    <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3}>
                      {showOtpBtn === true ? (
                        <Button
                          variant="secondary"
                          type="submit"
                          className="bg-dark submit-btn mt-4"
                        >
                          Generate OTP{" "}
                        </Button>
                      ) : showOtpBtn === false ? (
                        <React.Fragment>
                          {resendOtp === false ? (
                            <Form.Label className="input-lable mb-3 mt-4">
                              OTP Sent to &nbsp;
                              <b className="text-primary">
                                {Formik?.values?.mobileNo}{" "}
                              </b>
                            </Form.Label>
                          ) : resendOtp === true ? (
                            <React.Fragment>
                              <Form.Label className="input-lable mt-2">
                                Didn't receive code?{" "}
                              </Form.Label>
                              <Button
                                variant="primary"
                                type="button"
                                className="submit-btn"
                                onClick={() => {
                                  resendOTP();
                                }}
                              >
                                Resend OTP{" "}
                              </Button>
                            </React.Fragment>
                          ) : (
                            ""
                          )}
                        </React.Fragment>
                      ) : (
                        ""
                      )}
                    </Col>
                    {showOtpBtn === false ? (
                      <React.Fragment>
                        <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3}>
                          <Form.Label className="input-lable mb-3 mt-4">
                            Time Remaining: {formatTime(timer)}
                          </Form.Label>
                        </Col>
                        <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3}>
                          <Form.Group controlId="otp">
                            <Field
                              type="text"
                              name="otp"
                              className="input-field form-control mt-4"
                              placeholder="Enter OTP"
                              maxLength={6}
                            />
                          </Form.Group>
                        </Col>
                        <Col
                          xs={12}
                          sm={12}
                          md={6}
                          lg={3}
                          xl={3}
                          xxl={3}
                          className="pt-2"
                        >
                          <Button
                            variant="success"
                            type="button"
                            className="submit-btn btn-success float-end mt-3"
                            onClick={() => {
                              submitValues();
                            }}
                          >
                            Submit
                          </Button>
                        </Col>
                      </React.Fragment>
                    ) : (
                      ""
                    )}
                  </Row>
                </React.Fragment>
              )}
            </Form>
          </FormikProvider>
        </Container>
      )}
    </React.Fragment>
  );
}

function getInitialValues() {
  return {
    aadhaarNo: "",
    applicantName: "",
    surName:"",
    fatherName: "",
    motherName: "",
    mobileNo: "",
    exService: "",
    gender: "",
    maritalStatus: "",
    caste: "",
    isEws: "",
    isTelangana: "",
    claimingDistrict: "",
    dob: "",
    district: "",
    address: "",
    village: "",
    email: "",
    doorNo: "",
    pinCode: "",
    isSports: "",
    mandal: "",
    isAndhra: "",
    isPh: "",
    isVh: "",
    isOh: "",
    isHi: "",
    isMi: "",
    // isScribe: "",
    vhPercentage: "",
    hiPercentage: "",
    ohPercentage: "",
    miPercentage: "",
    otp: "",
    selfCheck: false,
    isExServiceMen: "",
    state: "",
    subCasteCode: "",
    managementId: "",
  };
}
